// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"472":"fd54d6a3","573":"0af9c700","897":"f67bae78"}[chunkId] + ".js";
};